import { Button, Tooltip } from "@suraasa/placebo-ui"
import { Theme, useMediaQuery } from "@suraasa/placebo-ui-legacy"
import { CpatAssessmentQuestion } from "api/resources/cpat/types"
import clsx from "clsx"
import SlidingSheet from "components/SlidingSheet"
import { ArrowLeft, ArrowRight, NavArrowDown, NavArrowUp } from "iconoir-react"
import { useState } from "react"
import { createUseStyles, useTheme } from "react-jss"

import QuestionPanel from "../QuestionPanel"
import shepherdClass from "../shepherdClasses"

// import { GA } from "shared/utils/googleAnalytics"

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    backgroundColor: theme.colors.onSurface[300],
    borderBottomRightRadius: 8,
    borderBottomLeftRadius: 8,
    [theme.breakpoints.down("md")]: {
      borderRadius: 0,
    },
  },
  color: {
    color: theme.colors.common.white[500],
  },
  dialogContent: {
    position: "relative",
  },
}))

const AssessmentFooter = ({
  onNext,
  onPrevious,
  onQuestionChange,
  questions,
  currentQuestion,
}: {
  onNext: () => void
  onPrevious: () => void
  onQuestionChange: (questionNumber: number) => void
  questions: CpatAssessmentQuestion[]
  currentQuestion: CpatAssessmentQuestion
}) => {
  const classes = useStyles()
  const theme = useTheme<Theme>()
  const [questionsTrayOpen, toggleQuestionsTrayOpen] = useState(false)

  const isMdDown = useMediaQuery(theme.breakpoints.down("md"))
  const isXsDown = useMediaQuery(theme.breakpoints.down("xs"))

  // const ref = useRef<HTMLDivElement>(null)

  /**
   * This useEffect is responsible for closing the questions panel if user clicks outside it
   */
  // useEffect(() => {
  //   const container = ref.current
  //   const listener = function (event: any) {
  //     if (event && container)
  //       if (container.contains(event.target)) {
  //         // Clicked inside
  //       } else {
  //         // Clicked outside
  //         if (questionsTrayOpen) {
  //           toggleQuestionsTrayOpen(false)
  //         }
  //       }
  //   }
  //   if (container) {
  //     document.body.addEventListener("click", listener)
  //   }

  //   return () => {
  //     document.body.removeEventListener("click", listener)
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [questionsTrayOpen])

  const isFirstQuestion = currentQuestion.sequence === 1
  const isLastQuestion = currentQuestion.sequence === questions.length

  if (isMdDown) {
    return (
      <>
        <SlidingSheet
          open={questionsTrayOpen}
          onClose={() => {
            toggleQuestionsTrayOpen(false)
          }}
          className="max-h-[80vh] max-w-[900px]"
        >
          <QuestionPanel
            onClose={() => {
              toggleQuestionsTrayOpen(false)
            }}
            onQuestionChange={questionNumber => {
              toggleQuestionsTrayOpen(false)
              onQuestionChange(questionNumber)
            }}
            questions={questions}
            currentQuestion={currentQuestion}
          />
        </SlidingSheet>
        <div
          className={clsx(
            classes.container,
            "px-2 py-1 sm:flex sm:items-center sm:justify-between"
          )}
        >
          {!isXsDown && (
            <Button
              variant="text"
              className={clsx(
                classes.color,
                shepherdClass["questionsTrayButton"]
              )}
              onClick={() => {
                toggleQuestionsTrayOpen(prev => !prev)
              }}
            >
              <div className="grid grid-flow-col items-center gap-0.5 text-black">
                {questionsTrayOpen ? <NavArrowDown /> : <NavArrowUp />}
                Questions Tray
              </div>
            </Button>
          )}

          <div className="grid grid-flow-col items-center justify-between sm:justify-end sm:gap-1">
            <div>
              <Tooltip
                content="This is the first question"
                enabled={isFirstQuestion}
              >
                <div>
                  <Button
                    size="sm"
                    color="black"
                    startAdornment={!isXsDown && <ArrowLeft />}
                    onClick={onPrevious}
                    className={shepherdClass["prevButton"]}
                    disabled={isFirstQuestion}
                  >
                    Previous
                  </Button>
                </div>
              </Tooltip>
            </div>
            {isXsDown && (
              <Button
                variant="text"
                className={clsx(
                  classes.color,
                  shepherdClass["questionsTrayButton"]
                )}
                onClick={() => toggleQuestionsTrayOpen(prev => !prev)}
              >
                <div className="grid grid-flow-col items-center gap-0.5 text-black">
                  {questionsTrayOpen ? <NavArrowDown /> : <NavArrowUp />}
                  Questions
                </div>
              </Button>
            )}
            <div>
              <Tooltip
                content="This is the last question"
                enabled={isLastQuestion}
              >
                <div>
                  <Button
                    size="sm"
                    color="black"
                    endAdornment={!isXsDown && <ArrowRight />}
                    onClick={onNext}
                    className={shepherdClass["nextButton"]}
                    disabled={isLastQuestion}
                  >
                    Next
                  </Button>
                </div>
              </Tooltip>
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <div
      className={clsx(
        classes.container,
        "grid grid-flow-col items-center justify-end gap-1 px-2 py-1 lg:mb-0.5"
      )}
    >
      <Tooltip content="This is the first question" enabled={isFirstQuestion}>
        <div>
          <Button
            size="sm"
            startAdornment={!isXsDown && <ArrowLeft />}
            color="black"
            onClick={onPrevious}
            className={shepherdClass["prevButton"]}
            disabled={isFirstQuestion}
          >
            Previous
          </Button>
        </div>
      </Tooltip>
      <Tooltip content="This is the last question" enabled={isLastQuestion}>
        <div>
          <Button
            size="sm"
            color="black"
            className={shepherdClass["nextButton"]}
            endAdornment={!isXsDown && <ArrowRight />}
            onClick={onNext}
            disabled={isLastQuestion}
          >
            Next
          </Button>
        </div>
      </Tooltip>
    </div>
  )
}

export default AssessmentFooter
